<template>
  <div class="wrapper-show-all-tours">
    <nuxt-link
      :to="`/search?type=${type}&value=${value}`"
      class="el-button el-button--primary el-button--medium"
      @click.native="handleLoading"
      >{{ $t(`general.show_more`) }}</nuxt-link
    >
  </div>
</template>

<script>
import LadSearchCustomLoadingMixin from '@/utils/mixin/search-custom-loading'

export default {
  name: 'LadSearchShowAllTours',
  mixins: [LadSearchCustomLoadingMixin],
  props: {
    type: { type: String, default: 'country' },
    value: { type: String, required: true },
  },
}
</script>

<style lang="scss">
.wrapper-show-all-tours {
  text-align: center;
  margin-top: 40px;
}
</style>
